import { Host, h } from '@stencil/core';
import cn from 'classnames';
export class PartnerPrice {
  constructor() {
    this.price = undefined;
    this.priceLabel = undefined;
    this.isMobile = false;
  }
  render() {
    return (h(Host, { class: "pes-partner-price" }, this.priceLabel && h("p", { class: "pes-partner-price-label" }, this.priceLabel), h("span", { class: cn('pes-partner-price-value', this.isMobile && 'pes-partner-price-value--mobile') }, this.price)));
  }
  static get is() { return "pes-partner-price"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-partner-price.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-partner-price.css"]
    };
  }
  static get properties() {
    return {
      "price": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Partner price value"
        },
        "attribute": "price",
        "reflect": false
      },
      "priceLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Partner price label preceding the partner price value"
        },
        "attribute": "price-label",
        "reflect": false
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
}
